<template>
  <div class="vacancy-list-detail-item">
    <div class="vacancy-list-detail-item__title">
      <RouterLink :to="getVacancyLink(vacancy.id)">
        {{ vacancy.title }}
      </RouterLink>
    </div>
<!--    <div class="vacancy-list-detail__item" v-if="vacancy.salary">
      <span class="vacancy-list-detail__caption">{{ $t('salary') }}</span>
      <VacancySalary :salary="vacancy.salary" class="vacancy-list-detail__value" />
    </div>-->
    <div class="vacancy-list-detail-item__text" v-if="vacancy.address">
      <span class="vacancy-list-detail-item__value">{{ vacancy.address.city }}</span>
    </div>
    <!--    <div>-->
    <!--      <VBtn @click="$emit('excluded',vacancy.id)">-->
    <!--        Удалить-->
    <!--      </VBtn>-->
    <!--    </div>-->
  </div>
</template>

<script>

import VacancySalary from '@/components/Vacancy/VacancySalary';

export default {
  name: 'VacanciesListDetailListItem',
  components: { VacancySalary },
  props: {
    vacancy: {
      type: Object,
      required: true,
    },
  },
  setup() {
    function getVacancyLink(id) {
      return { name: 'vacancy', params: { id } };
    }
    return {
      getVacancyLink,
    };
  },
};
</script>

<style lang="scss" scoped>
.vacancy-list-detail-item {
  padding: 0.875rem 0;
  border-top: 1px solid #EEEEEE;
  &:first-child {
    border: none;
  }
  &__text {
    color: #212121;
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.11;
  }
  &__title {
    font-size: 1rem;
    line-height: 1.11;
    color: #0A82D9;
    margin-bottom: 0.375rem;
  }
}

</style>
